import gql from 'graphql-tag';

export const UPDATE_LOOK_WEIGHTED_QUESTION_FILTER = gql`
  mutation updateLookWeightedQuestionFilter($filter: VerticalFilterInput!, $orderBy: [String]) {
    updateLookWeightedQuestionFilter(filter: $filter, orderBy: $orderBy) @client
  }
`;
